import * as React from "react";
import {Link} from "react-router-dom";
import Axios from "../Components/Axios";
import './Buy.scss';
import { default as l } from "../../Langs/Langs";

class BuyInfo extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            service: this.props.match.params.service,
            lang: this.props.match.params.lang === 'kg' ? 'kg' : 'ru',
            source: this.props.match.params.source ?? 'no'
        };
        document.title = 'Информация об услуге';
        setTimeout(()=>{
            try {
                document
                    .getElementsByClassName('buy-page')
                    .item(0)
                    .style
                    .opacity = 1;
            }
            catch (E){
            }
        }, 200);
    }

    getInfo() {
        Axios
            .get(`api/service/${this.state.service}/info`)
            .then(r => this.setState({
                data: r.data
            }));
    }

    logInfo() {
        Axios.get(`api/connect/info_log/${this.state.service}`).then(r => {});
    }

    componentDidMount() {
        this.getInfo();
        this.logInfo();
    }

    render() {
        const lang = this.state.lang;
        const langUp = lang.charAt(0).toUpperCase() + lang.slice(1);
        return (
            <div className="container-fluid m-0 p-0 buy-page">
                <div className="header shadow p-2 text-bold h5 m-0" style={{"lineHeight": "45px"}}>
                    <Link to={`/${this.state.service}/${this.state.source}/${lang}` } className="btn btn-success mr-3">{ l[lang].v('← Назад') }</Link>
                    { this.state?.data?.['title' + langUp] }
                </div>
                <iframe title={'information'} frameBorder="0" src={this.state?.data?.['moreUrl' + langUp]} />
            </div>
        );
    }
}

export default BuyInfo;